import ActivationReportComponent from "../../Component/Activation/ActivationReportComponent"

const ActivationReport = () => {
    return (
      <div className='page-body'>
        <ActivationReportComponent />
      </div>
    )
  }
  
  export default ActivationReport